import { createCustomEnum } from "./customEnum";

const TerminalGatewayTypes = createCustomEnum({
	ARISE: {
		name: "ARISE",
		displayName: "ARISE",
		value: 17,
	},
	AuthorizeNet: {
		name: "AuthorizeNet",
		displayName: "Authorize.net",
		value: 1,
	},
	BridgePay: {
		name: "BridgePay",
		displayName: "Bridge Pay",
		value: 2,
	},
	BridgePayTGate: {
		name: "BridgePayTGate",
		displayName: "Bridge Pay (T-Gate)",
		value: 3,
	},
	Converge: {
		name: "Converge",
		displayName: "Converge",
		value: 9,
	},
	EPN: {
		name: "EPN",
		displayName: "EPN",
		value: 10,
	},
	NMI: {
		name: "NMI",
		displayName: "NMI",
		value: 5,
	},
	Payeezy: {
		name: "Payeezy",
		displayName: "Payeezy",
		value: 7,
	},
	PayflowPro: {
		name: "PayflowPro",
		displayName: "Payflow Pro",
		value: 12,
	},
	Paytrace: {
		name: "Paytrace",
		displayName: "Paytrace",
		value: 6,
	},
	RiseOS: {
		name: "RiseOS",
		displayName: "RiseOS",
		value: 16,
	},
	SwipeSimple: {
		name: "SwipeSimple",
		displayName: "SwipeSimple",
		value: 15,
	},
	USAEPAY: {
		name: "USAEPAY",
		displayName: "USAEPAY",
		value: 4,
	},
	ValorPayTech: {
		name: "ValorPayTech",
		displayName: "Valor PayTech",
		value: 14,
	},
	Other: {
		name: "Other",
		displayName: "Other",
		value: 11,
	},
});

export default TerminalGatewayTypes;
